<template>
  <div class="video-wrapper">
    <div v-if="!isPlayerVisible" class="video-thumbnail">
      <img
        class="thumbnail-image"
        :src="thumbnailUrl"
        alt="Video thumbnail"
        loading="lazy"
      />
      <button
        class="play-button"
        aria-label="Play video"
        @click="showPlayer"
      ></button>
    </div>

    <iframe
      v-else
      ref="iframe"
      :src="iframeSrc"
      frameborder="0"
      allow="autoplay; fullscreen"
      allowfullscreen
      style="width: 100%; height: 100%"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "YouTubePlayerSimple",
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    thumbnailImage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isPlayerVisible: false,
    };
  },
  computed: {
    videoId() {
      const match = this.videoUrl?.match(/(?:\/embed\/|v=)([a-zA-Z0-9_-]+)/);
      return match ? match[1] : null;
    },
    thumbnailUrl() {
      return this.thumbnailImage
        ? this.thumbnailImage
        : this.videoId
        ? `https://img.youtube.com/vi/${this.videoId}/hqdefault.jpg`
        : "";
    },
    iframeSrc() {
      return `https://www.youtube.com/embed/${this.videoId}?autoplay=1&mute=1&rel=0&modestbranding=1`;
    },
  },
  methods: {
    showPlayer() {
      this.isPlayerVisible = true;
    },
  },
};
</script>
